"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>HotelListingCard
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_HotlListingCard_styles_js_namespaceObject = require("./HotlListingCard.styles.js");
const Header_js_namespaceObject = require("./components/Header/Header.js");
var Header_js_default = /*#__PURE__*/ __webpack_require__.n(Header_js_namespaceObject);
const Ratings_js_namespaceObject = require("./components/Ratings/Ratings.js");
var Ratings_js_default = /*#__PURE__*/ __webpack_require__.n(Ratings_js_namespaceObject);
const Price_js_namespaceObject = require("./components/Price/Price.js");
var Price_js_default = /*#__PURE__*/ __webpack_require__.n(Price_js_namespaceObject);
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const index_js_namespaceObject = require("../../utils/index.js");
const external_BookHotelNowButton_js_namespaceObject = require("../BookHotelNowButton.js");
const external_uuid_namespaceObject = require("uuid");
const external_ChooseHotelRoomButton_js_namespaceObject = require("../ChooseHotelRoomButton.js");
const external_HotelAISummary_js_namespaceObject = require("./HotelAISummary.js");
const external_buildHotelDetailURL_js_namespaceObject = require("./buildHotelDetailURL.js");
const useRealTimeContext_js_namespaceObject = require("../../hooks/useRealTimeContext.js");
const ExpressDealBadge_js_namespaceObject = require("./components/ExpressDealBadge/ExpressDealBadge.js");
var ExpressDealBadge_js_default = /*#__PURE__*/ __webpack_require__.n(ExpressDealBadge_js_namespaceObject);
const HotelListingCard_HotelListingCard = ({ listingProps, hotel, args })=>{
    const { imageSrc, headerText, ratingsProps, priceProps } = listingProps ?? {};
    const { setiValues, fetchRequestOptions, shouldDisplayGenHotelFeature, submitChatMessagesPayload } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { startRealTime } = (0, useRealTimeContext_js_namespaceObject.useRealTimeContext)();
    const { starRating, location, pclnPropertyTypeId, hotelType, description, ratesSummary, itemKey, hotelAISummary } = hotel ?? {};
    const isExpressDeal = 'SOPQ' === hotelType;
    const shouldDisplayCheckoutButton = setiValues.shouldDisplayCheckoutButton;
    const transformSopqNameArgs = {
        starRating,
        location,
        pclnPropertyTypeId
    };
    const propertyName = isExpressDeal && !hotel.name ? (0, index_js_namespaceObject.transformSOPQName)(transformSopqNameArgs) : hotel.name;
    const detailURL = (0, external_buildHotelDetailURL_js_namespaceObject.buildHotelDetailURL)(args, hotel);
    const { priceDisplayRegulation, minCurrencyCodeSymbol, minCurrencyCode, nightlyRateIncludingTaxesAndFees, grandTotal, minPrice, priceKey } = ratesSummary || {};
    const showHotelPrice = 'TOTAL_PRICE_PROMINENT' === priceDisplayRegulation ? minCurrencyCodeSymbol && !isNaN(nightlyRateIncludingTaxesAndFees) && !isNaN(grandTotal) : minCurrencyCodeSymbol && !isNaN(minPrice) && !isNaN(grandTotal);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_HotlListingCard_styles_js_namespaceObject.ListingCardWrapper, {
        borderRadius: 'xl',
        boxShadow: 'lg',
        onClick: (0, external_ChooseHotelRoomButton_js_namespaceObject.handleChooseHotelRoomButtonClick)({
            hotelId: hotel.hotelId,
            args,
            detailURL
        }),
        mb: '20px',
        pb: '10px',
        bg: startRealTime ? 'text.lightest' : 'null',
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                children: [
                    isExpressDeal && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ExpressDealBadge_js_default(), {}),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_HotlListingCard_styles_js_namespaceObject.Img, {
                        src: imageSrc
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                p: 2,
                pb: '0',
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                        height: '120px',
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Header_js_default(), {
                                    ...headerText
                                })
                            }),
                            hotelAISummary ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                fontSize: 0,
                                lineHeight: "20px",
                                pb: 1,
                                pt: 2,
                                children: hotelAISummary
                            }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_HotelAISummary_js_namespaceObject.HotelAISummaryMemo, {
                                shouldDisplayGenHotelFeature: shouldDisplayGenHotelFeature,
                                propertyName: propertyName,
                                isExpressDeal: isExpressDeal,
                                fetchRequestOptions: fetchRequestOptions,
                                description: description,
                                starRating: starRating,
                                hotelAmenities: hotel.hotelFeatures?.hotelAmenities,
                                petDescription: hotel?.policies?.petDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        mt: 3,
                        height: '20px',
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Ratings_js_default(), {
                                    ...ratingsProps
                                }),
                                ' '
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Divider, {
                width: 1,
                my: 1
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                p: 0,
                px: 2,
                pb: 2,
                height: [
                    '100px',
                    '70px'
                ],
                children: showHotelPrice ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Price_js_default(), {
                    ...priceProps
                }) : null
            }),
            shouldDisplayCheckoutButton ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                p: 0,
                px: 2,
                mt: 2,
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ChooseHotelRoomButton_js_namespaceObject.ChooseHotelRoomButton, {
                        hotelId: hotel.hotelId,
                        args: args,
                        buttonProps: {
                            variation: 'subtle',
                            width: '100%'
                        },
                        detailURL: detailURL,
                        buttonCopy: "Choose Room"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_BookHotelNowButton_js_namespaceObject.BookHotelNowButton, {
                        buttonProps: {
                            variation: 'fill',
                            color: 'secondary',
                            width: '100%',
                            ml: 2
                        },
                        cguid: submitChatMessagesPayload?.cguid,
                        rguid: (0, external_uuid_namespaceObject.v4)(),
                        itemKey: itemKey,
                        priceKey: priceKey,
                        nightlyRateIncludingTaxesAndFees: nightlyRateIncludingTaxesAndFees,
                        minCurrencyCode: minCurrencyCode,
                        minCurrencyCodeSymbol: minCurrencyCodeSymbol
                    })
                ]
            }) : null
        ]
    });
};
const HotelListingCard = HotelListingCard_HotelListingCard;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
